module.exports = __webpack_public_path__ + "img/knee.a0e6b93e.png";